import { render, staticRenderFns } from "./link-back.vue?vue&type=template&id=5ef99fb2&scoped=true&"
import script from "./link-back.vue?vue&type=script&lang=js&"
export * from "./link-back.vue?vue&type=script&lang=js&"
import style0 from "./link-back.vue?vue&type=style&index=0&id=5ef99fb2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef99fb2",
  null
  
)

export default component.exports